import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, ValidatorFn, AsyncValidatorFn } from '@angular/forms';
import { ControlContainer, FormGroup, FormBuilder } from '@angular/forms';
import { Inject, Optional, Host, SkipSelf } from '@angular/core';

import { ValueAccessorValidatedBase } from '../../form/value-accessor-validated';
import { HomeController } from '../../../../controllers/home/home.controller';
import { SelectItemDto } from '@shared/src/dtos/base/select/SelectItemDto';
import { HLong } from '@shared/src/datatypes/HLong';

@Component({
  selector: 'select-component',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: SelectComponent, multi: true }
  ]
})

export class SelectComponent extends ValueAccessorValidatedBase<SelectItemDto, any> {

  createForm(validators: ValidatorFn[], asyncvalidators: AsyncValidatorFn[]) {
    this.rFormInput = this.fb.group({
      'dtpvalidator': ['', validators, asyncvalidators]
    });
  }

  isValid(value: SelectItemDto): boolean {
    return true;
  }

  rFormInput: FormGroup;
  public useIonic: boolean = false;
  constructor(
    @Optional() @Host() @SkipSelf() controlContainer: ControlContainer,
    @Optional() @Inject(NG_VALIDATORS) validators: ValidatorFn[],
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: AsyncValidatorFn[],
    private fb: FormBuilder,
    @Inject('HomeController') protected homecontroller: HomeController
  ) {
    super(controlContainer, validators, asyncValidators);
    if (homecontroller.useIonic)
      this.useIonic = homecontroller.useIonic();
  }

  @Input() public label: string;
  @Input() public helpresource: string;
  @Input() public color: string = 'primary';
  @Input() public readonly: boolean;
  @Input() public showHelpPoint: boolean;
  @Input() public autocomplete: string = "off";
  @Input() public type: string = "text";
  @Input() public name: string = null;
  @Input() public autoselectwhenone: boolean = false;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  compareFn = (a: SelectItemDto, b: SelectItemDto) => a && b && a.id === b.id;

  private _options: Array<SelectItemDto> = [];
  @Input() set options(value: Array<SelectItemDto>) {
    if (this._options === value)
      return;
    this._options = value;
    this.loadSelectValue();
  }
  get options(): Array<any> {
    return this._options;
  }

  
  private _selectId: any;
  @Input() set selectId(value: any) {
    if (this._selectId === value)
      return;
    this._selectId = value;
    this.loadSelectValue();
  }
  get selectId(): any {
    return this._selectId;
  }

  public identifier = 'select-' + identifier++;

  externalValue(value: SelectItemDto): any {

    if (value == null)
      return null;

    return value.id;

  }

  internalValue(value: any): SelectItemDto {
    return this.value;
  }
 
  onChange(e) {
    this.valueChanged.next(this.value);
  }

  loadSelectValue(){
    if(this.selectId == null){
      if(this.value != null)
        this._selectId = this.value.id;
      else if(this.autoselectwhenone){
        if (this.options && this.options.length == 1) {
          this.value = this.options[0];
          this._selectId = this.value.id;
          this.valueChanged.next(this.value);
        }
      }
    } else{
      if(this.value != null){
        if(this.selectId == this.value.id){
          return;
        }
      }
      if (this.options){
        this.options.forEach(opcio => {
          if(opcio.id == this.selectId){
            this.value = opcio;
            return;
          }
        });  
      }
    }
  }
 
}

let identifier = 0;